import { gql } from "@apollo/client";

export const GET_READERS = gql`
  query getBooks {
    booksTitles {
      id
      is_author
      title
      coming_soon
      image_ver
      description_short
      themes
      author {
        name
      }
      images {
        cover
      }
      language {
        id
        name
      }
    }
  }
`;
